var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuOption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.52753 5.81992C2.13937 6.55869 1.85088 7.35802 1.67996 8.20006M6.31992 2.02753C7.05873 1.63936 7.85807 1.35088 8.70011 1.17996M14.6802 2.02753C13.9414 1.63936 13.142 1.35088 12.3 1.17996M18.4723 5.81992C18.8605 6.55869 19.149 7.35802 19.3199 8.20006M18.4723 14.1802C18.8605 13.4414 19.149 12.642 19.3199 11.8M14.6802 17.9723C13.9414 18.3605 13.142 18.649 12.3 18.8199M6.31992 17.9723C7.05873 18.3605 7.85807 18.649 8.70011 18.8199M2.52753 14.1802C2.13937 13.4414 1.85088 12.642 1.67996 11.8M10.5 12.7V7.3M7.8 10H13.2M4.2 6.4C5.69116 6.4 6.9 5.19116 6.9 3.7C6.9 2.20883 5.69116 1 4.2 1C2.70883 1 1.5 2.20883 1.5 3.7C1.5 5.19116 2.70883 6.4 4.2 6.4ZM16.8 6.4C18.2912 6.4 19.5 5.19116 19.5 3.7C19.5 2.20883 18.2912 1 16.8 1C15.3088 1 14.1 2.20883 14.1 3.7C14.1 5.19116 15.3088 6.4 16.8 6.4ZM16.8 19C18.2912 19 19.5 17.7912 19.5 16.3C19.5 14.8088 18.2912 13.6 16.8 13.6C15.3088 13.6 14.1 14.8088 14.1 16.3C14.1 17.7912 15.3088 19 16.8 19ZM4.2 19C5.69116 19 6.9 17.7912 6.9 16.3C6.9 14.8088 5.69116 13.6 4.2 13.6C2.70883 13.6 1.5 14.8088 1.5 16.3C1.5 17.7912 2.70883 19 4.2 19Z",
    stroke: "#006386",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuOption);
export default __webpack_public_path__ + "static/media/menu-option.259b3beb15556ec0e2b653fb8c1602c5.svg";
export { ForwardRef as ReactComponent };